module.exports = __webpack_public_path__ + "static/img/putiItemNew2.267b0f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/putiItemNew2.jpg
// module id = qUQp
// module chunks = 0